import { Component, OnInit } from '@angular/core';
import { PeerToPeerConfirmationComponent } from '../peer-to-peer-confirmation/peer-to-peer-confirmation.component';
import { SharedPeerToPeerModule } from '@pages/send-money/components/peer-to-peer/shared-peer-to-peer.module';
import { SharedPeerToPeerComponent } from '@pages/send-money/components/peer-to-peer/shared-peer-to-peer.component';
@Component({
    standalone: true,
    selector: 'app-peer-to-peer',
    templateUrl: './peer-to-peer.component.html',
    styleUrls: ['./peer-to-peer.component.scss'],
    imports: [SharedPeerToPeerModule],
})
export class PeerToPeerComponent extends SharedPeerToPeerComponent implements OnInit {
    override ngOnInit(): void {
        super.ngOnInit();
        this.redirectToComponent = PeerToPeerConfirmationComponent;
        this.form.controls.senderCurrency.valueChanges.subscribe((currency) => {
            this.form.controls.receiverCurrency.setValue(currency);
        });
    }
}
